var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-auto"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.runBackup}},[_c('i',{staticClass:"bi bi-layer-backward"}),_vm._v(" Backup")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }